<template>
<div v-if="isTgApp || isPWA" class="block mb-3" style="height:52px" :class="(hideHeader) ? 'surface-200' : ''"></div>
<div v-else class="block xl:hidden lg:hidden md:hidden mb-3" style="height:52px"></div>

<FixedMobile>
    <template v-slot:body>
        <div class="flex w-full flex-row">
            <div class="flex flex-column py-2 gap-1">
                <span class="flex text-900 font-medium text-xl">
                    Перевод
                </span>
                <span v-if="type">
                    <div class="py-1 px-2 flex text-xs border-round-md font-semibold border-2 surface-border cursor-pointer text-500 font-medium align-items-center" >
                        <span class="flex">
                            {{ getTypeTitle(type)}}
                        </span>
                    </div>
                </span>
            </div>
            <div class="flex flex-row w-full mt-2 mb-2">
                <span v-if="transfer">
                    <div :class="'status-'+transfer.status" 
                        class="ml-2 py-1 px-2 flex text-xs border-round-md font-semibold border-2 surface-border cursor-pointer text-500 font-medium align-items-center" >
                        <span class="flex">{{getStatusLabel(transfer.status)}}</span>
                    </div>
                </span>
                <span v-if="transfer">
                    <div @click="copy(transfer.id)" class="ml-2 py-1 px-2 flex text-xs border-round-md font-semibold border-2 surface-border cursor-pointer text-500 font-medium align-items-center" >
                        <span class="flex">{{get_short_id(transfer.id)}}</span>
                        <span class="flex pi pi-copy ml-2 text-500 text-sm cursor-pointer"></span>
                    </div>
                </span>
            </div>
        </div>
    </template>
</FixedMobile>

<Page type="gray" :nopadding="true">
    <template v-slot:body>
        <div v-if="transfer" class="flex flex-column w-full surface-0 
            pt-4 pl-3 pr-3 xl:p-6 lg:p-5 md:p-4 
            xl:border-round-3xl lg:border-round-2xl">

            <div class="hidden w-full xl:flex lg:flex md:flex flex-row align-items-center mb-4 gap-2">
                <span class="flex text-900 font-medium mr-3 text-3xl xl:text-6xl lg:text-5xl md:text-4xl">
                    Перевод
                </span>
                <span v-if="transfer" class="flex">
                    <div :class="'status-'+transfer.status" 
                        class="px-3 h-2rem flex flex-row text-sm border-round-lg font-semibold border-2 surface-border cursor-pointer text-500 font-medium align-items-center" >
                        <span class="flex">{{getStatusLabel(transfer.status)}}</span>
                    </div>
                </span>
                <Button :label="get_short_id(transfer.id)" @click='copy(transfer.id)' 
                    size="small" outlined icon="pi pi-copy" class="border-2 border-round-lg" severity="secondary"/>
                <Button v-if="transfer && isUserInGroup('admin')" label="Tx" @click='toTrans(transfer.id)' 
                    size="small" outlined icon="pi pi-external-link" class="border-2 border-round-lg" severity="secondary"/>
                <Button v-if="transfer" label="Обновить" @click='LoadTransfer()' :loading="isLoading" 
                    size="small" outlined icon="pi pi-refresh" class="border-2 border-round-lg" severity="secondary"/>
            </div>

            <div class="w-full flex flex-column xl:flex-row xl:gap-3 xl:mb-3">

                <div class="w-full flex flex-column xl:flex-row relative xl:mb-0 mb-2">
                    <div class="w-full flex flex-column relative surface-100 border-round-xl xl:border-round-2xl p-3 xl:p-4">
                        <span class="flex text-sm xl:text-lg text-600 mb-3">
                            К получению: 
                        </span>
                        <span class="flex text-2xl xl:text-3xl font-semibold text-900 mb-3 xl:mb-4">
                            {{ getFormatAmount(transfer.sender.amount, transfer.sender.currency_code, 2) }}
                        </span>
                        <span class="flex text-sm xl:text-base mb-2">
                            <span class="text-600">Курс:</span> 
                            <span class="ml-2">{{ transfer.rate }}</span>
                        </span>
                        <div v-if="sender" class="w-full flex flex-column gap-2 mb-2 text-sm xl:text-base">
                            <span v-if="sender.name && sender.id" class="flex">
                                <span class="text-600">Отправитель:</span>
                                <span class="ml-2">{{ sender.name }}</span>
                                <span @click="go_to_user(sender.id)" class="cursor-pointer flex text-primary ml-2">
                                    {{ get_short_id(sender.id)}} <span class="pi pi-external-link flex ml-2"></span>
                                </span>
                            </span>

                            <span v-if="sender.email" class="flex">
                                <span class="text-600">Почта:</span>
                                <a :href="'mailto:'+sender.email" target="_blank" class="cursor-pointer flex text-primary ml-2">
                                    {{ sender.email }}
                                </a>
                            </span>

                            <span v-if="sender.prefix && sender.phone" class="flex">
                                <span class="text-600">WhatsApp:</span>
                                <a :href="'https://wa.me/'+sender.prefix+sender.phone" target="_blank" class="cursor-pointer flex text-primary ml-2">
                                    {{ sender.prefix }}{{ sender.phone }}
                                </a>
                            </span>

                            <span v-if="sender.telegram && sender.telegram.username" class="flex text-600">
                                <span class="text-600">Telegram:</span>
                                <a :href="'https://t.me/'+sender.telegram.username" target="_blank" class="cursor-pointer flex text-primary ml-2">
                                    {{ sender.telegram.username }}
                                </a>
                            </span>

                            <span v-if="sender.sendpulse && sender.sendpulse.id" class="flex">
                                <span class="text-600">Sendpulse:</span>
                                <a :href="`https://login.sendpulse.com/chatbots/chats?contact_id=${sender.sendpulse.id}&channel=telegram`" target="_blank" class="cursor-pointer flex text-primary ml-2">
                                    перейти
                                </a>
                            </span>
                        </div>
                        
                        <div v-if="transfer.sender && transfer.dates" class="w-full flex flex-column mb-2 gap-2 text-sm xl:text-base">
                            <span v-if="transfer.sender.fullname" class="flex text-600">
                                <span>Имя отправителя: <span class="text-900 font-medium">{{ transfer.sender.fullname }}</span> </span>
                            </span>
                            <span v-if="transfer.sender.bank_code" class="flex text-600">
                                <span>Банк отправителя: <span class="text-900 font-medium">{{ getBankTitle(transfer.sender.bank_code) }}</span> </span>
                            </span>
                            <span v-if="transfer.dates.created" class="flex">
                                <span class="text-600">Дата создания: </span>
                                <span class="ml-2">{{ formatDate(transfer.dates.created) }} </span>
                            </span>
                            <span v-if="transfer.sender.confirm!==undefined" class="flex align-items-center">
                                <span class="text-600">Отметка клиентом: </span>
                                <Tag :severity="(transfer.sender.confirm) ? 'success' : 'warn'" class="text-sm ml-1"
                                    :value="(transfer.sender.confirm) ? 'Да' : 'Нет'" />
                                <span class="ml-2"> {{ (transfer.sender.confirm_date) ? formatDate(transfer.sender.confirm_date) : ''}}</span>
                            </span>
                            <span v-if="transfer.sender.description" class="flex flex-column gap-1 mt-2">
                                <span class="text-600">Описание: </span>
                                <span>{{ transfer.sender.description }}</span>
                            </span>
                            <span v-if="transfer.sender.sender_id" class="flex">
                                <span class="text-600">ID отправителя:</span>
                                <span class="ml-2">{{ get_short_id(transfer.sender.sender_id) }}</span>
                                <span @click="copy(transfer.sender.sender_id)" class="flex pi pi-copy ml-2 text-500 text-xs font-medium cursor-pointer"></span>
                                <span @click="go_to_sender(transfer.sender.sender_id)" class="flex pi pi-external-link cursor-pointer text-xs font-medium text-primary ml-2"></span>
                            </span>
                        </div>
                        <span v-if="transfer.cashback" class="flex align-items-center">
                            <span class="text-600">Списан кешбек:</span>
                            <span v-if="transfer.cashback.amount && transfer.cashback.currency_code" class="flex text-900 ml-2">
                                {{ getFormatAmount(transfer.cashback.amount, transfer.cashback.currency_code, 2) }}
                            </span>
                            <Tag :severity="(transfer.cashback.finalized) ? 'success' : 'warn'" class="text-sm ml-1"
                                :value="(transfer.cashback.finalized) ? 'Да' : 'Нет'" />
                        </span>
                    </div>
                </div>

                <div class="w-full flex flex-column xl:flex-row relative xl:mb-0 mb-2">
                    <div class="w-full flex flex-column relative surface-100 border-round-xl xl:border-round-2xl p-3 xl:p-4">
                        <span class="flex text-sm xl:text-lg text-900 mb-3">
                            К выплате: 
                        </span>
                        <span class="flex text-2xl xl:text-3xl font-semibold text-900 mb-3 xl:mb-4">
                            {{ getFormatAmount(transfer.recipient.amount, transfer.recipient.currency_code, 2) }}
                            <span class="pi pi-copy ml-2 text-500 xl:text-xl lg:text-lg md:text-md text-sm cursor-pointer" @click="copy(transfer.recipient.amount)"></span>
                        </span>
                        <div v-if="transfer.recipient" class="flex mb-2">
                            <Recipient :recipient="transfer.recipient"/>
                            <span v-if="transfer.recipient.description" class="flex flex-column gap-1 text-sm xl:text-base">
                                <span class="text-600">Описание: </span>
                                <span>{{ transfer.recipient.description }}</span>
                            </span>
                        </div>
                        <span v-if="transfer.partner" class="flex align-items-center">
                            <span class="text-600">
                                Начислен кешбек 
                                <span v-if="transfer.partner.has_referrer">партнеру</span>
                                <span v-else>клиенту</span>
                            :</span>
                            <span v-if="transfer.partner.amount" class="flex text-900 ml-2">
                                {{ getFormatAmount(transfer.partner.amount, 'usdt', 2) }}
                            </span>
                            <Tag :severity="(transfer.partner.payout) ? 'success' : 'warn'" class="text-sm ml-1"
                                :value="(transfer.partner.payout) ? 'Да' : 'Нет'" />
                            <span @click="go_to_user(transfer.partner.user_id)" class="text-sm cursor-pointer flex text-primary ml-2">
                                {{ get_short_id(transfer.partner.user_id)}} <span class="pi pi-external-link flex ml-2"></span>
                            </span>
                        </span>
                    </div>
                </div>
            </div>

            <RiskProfile v-if="transfer.risk" :risk="transfer.risk" class="xl:mb-3 mb-2" />

            <div v-if="transfer.service" class="w-full flex flex-column xl:flex-row relative xl:mb-3 mb-2">
                <div class="w-full flex flex-column relative surface-100 gap-2
                    p-3 xl:p-4
                    border-round-xl xl:border-round-2xl">
                    <span class="flex text-sm xl:text-lg text-900">
                        Сервис: 
                    </span>
                    <span v-if="transfer.service.review_id" class="flex text-sm xl:text-base text-600">
                        Счет: {{ (transfer.service.bill_id) ? transfer.service.bill_id : 'Нет' }}
                    </span>
                    <span v-if="transfer.free" class="flex text-sm text-600">
                        Первый перевод: {{ (transfer.free) ? 'Да' : 'Нет' }}
                    </span>
                    <span v-if="transfer.service.amount" class="flex text-sm">
                        <span class="text-600">Сумма перевода: </span>
                        <span class="ml-2">{{ getFormatAmount(transfer.service.amount, 'usdt') }}</span>
                    </span>
                    <span v-if="transfer.service.comission" class="flex text-sm align-items-center">
                        <span class="text-600">Комиссия сервиса: </span>
                        <span class="ml-2">{{ getFormatAmount(transfer.service.comission, 'usdt') }}</span>
                        <Tag :severity="(transfer.service.comission_paid) ? 'success' : 'warn'" class="text-xs ml-1"
                            :value="(transfer.service.comission_paid) ? 'Да' : 'Нет'" />
                    </span>
                    <span v-if="transfer.service.review_id" class="flex text-sm text-600">
                        <span>Отзыв: </span>
                        <span class="ml-2"> {{ (transfer.service.review_id) ? transfer.service.review_id : 'Нет' }}</span>
                    </span>
                    <span v-if="calcTotalCommission(transfer)" class="flex text-sm">
                        <span class="text-600">Общая комиссия: </span>
                        <span class="ml-2"> {{ calcTotalCommission(transfer) }}</span>
                    </span>
                </div>
            </div>

            <div v-if="transfer.get" class="w-full flex flex-column xl:flex-row xl:gap-3 xl:mb-3">
                <div class="w-full flex flex-column xl:flex-row relative xl:mb-0 mb-2">
                    <div class="w-full flex flex-column relative surface-100 gap-2
                        p-3 xl:p-4
                        border-round-xl xl:border-round-2xl">
                        <span class="flex text-sm xl:text-lg text-900">
                            Прием: 
                        </span>
                        <span v-if="transfer.get.type" class="flex text-sm">
                            <span class="text-600">Тип приема: </span>
                            <span class="ml-2">{{ get_payment_type_label(transfer.get.type) }}</span>
                        </span>
                        <span v-if="transfer.get.code" class="flex text-sm">
                            <span class="text-600">Платежная система: </span>
                            <span class="ml-2" v-if="transfer.get.code">{{ getPaySysTitle(transfer.get.code) || transfer.get.code}}</span>
                        </span>
                        <div v-if="transfer.get.payment_system" class="flex flex-column gap-2">
                            <span v-if="transfer.get.payment_system.vendor_code" class="flex text-sm">
                                <span class="text-600">Подрядчик: </span>
                                <span class="ml-2" v-if="transfer.get.payment_system.vendor_code">{{ transfer.get.payment_system.vendor_code }}</span>
                            </span>
                            <span v-if="transfer.get.payment_system.token" class="flex text-sm">
                                <span class="text-600">ID счета: </span>
                                <span class="ml-2" v-if="transfer.get.payment_system.token">{{ transfer.get.payment_system.token }}</span>
                            </span>
                            <span v-if="transfer.get.payment_system.comission" class="flex text-sm align-items-center">
                                <span class="text-600">Комиссия ПС приема: </span>
                                <span class="ml-2">{{ getFormatAmount(transfer.get.payment_system.comission, 'usdt') }}</span>
                                <Tag :severity="(transfer.get.payment_system.comission_paid) ? 'success' : 'warn'" class="text-xs ml-1"
                                    :value="(transfer.get.payment_system.comission_paid) ? 'Да' : 'Нет'" />
                            </span>
                            <span v-if="transfer.get.payment_system.amount" class="flex text-sm">
                                <span class="text-600">Сумма: </span>
                                <span class="ml-2">{{ getFormatAmount(transfer.get.payment_system.amount, 'usdt') }}</span>
                            </span>
                            <span v-if="transfer?.lifecycle?.external_ops?.payin?.vendor_code" class="flex text-sm">
                                <span class="text-600">code: </span>
                                <span class="ml-2">{{ transfer?.lifecycle?.external_ops?.payin?.vendor_code }}</span>
                            </span>
                            <span v-if="transfer?.lifecycle?.external_ops?.payin?.operation_id" class="flex text-sm">
                                <span class="text-600">OP ID: </span>
                                <span class="ml-2">{{ getShortTd(transfer?.lifecycle?.external_ops?.payin?.operation_id) }}</span>
                                <span @click="copy(transfer?.lifecycle?.external_ops?.payin?.operation_id)" class="flex pi pi-copy ml-2 text-500 text-xs font-medium cursor-pointer"></span>
                                <span @click="goToOp(transfer?.lifecycle?.external_ops?.payin?.operation_id)" class="flex pi pi-external-link cursor-pointer text-xs font-medium text-primary ml-2"></span>
                            </span>
                            <span v-if="transfer?.lifecycle?.external_ops?.payin?.idempotency_key" class="flex text-sm">
                                <span class="text-600">idempotency_key: </span>
                                <span class="ml-2">{{ getShortTd(transfer?.lifecycle?.external_ops?.payin?.idempotency_key) }}</span>
                                <span @click="copy(transfer?.lifecycle?.external_ops?.payin?.idempotency_key)" class="flex pi pi-copy ml-2 text-500 text-xs font-medium cursor-pointer"></span>
                            </span>
                            <span v-if="transfer?.lifecycle?.external_ops?.payin?.token" class="flex text-sm">
                                <span class="text-600">token: </span>
                                <span class="ml-2">{{ getShortTd(transfer?.lifecycle?.external_ops?.payin?.token) }}</span>
                                <span @click="copy(transfer?.lifecycle?.external_ops?.payin?.token)" class="flex pi pi-copy ml-2 text-500 text-xs font-medium cursor-pointer"></span>
                            </span>
                            <span v-if="transfer?.lifecycle?.external_ops?.payin?.created_at" class="flex text-sm">
                                <span class="text-600">Создано: </span>
                                <span class="ml-2">{{ formatDate(transfer?.lifecycle?.external_ops?.payin?.created_at) }}</span>
                            </span>
                            <span v-if="transfer?.lifecycle?.external_ops?.payin?.updated_at" class="flex text-sm">
                                <span class="text-600">Обновлено: </span>
                                <span class="ml-2">{{ formatDate(transfer?.lifecycle?.external_ops?.payin?.updated_at) }}</span>
                            </span>
                            <div v-if="transfer.get && transfer.get.payment_system" class="flex">
                                <Button @click='checkPayment()' :disabled="isLoading" severity="info" size="small"
                                    label="Проверить оплату" icon="pi pi-check"  iconPos="right" class="border-round-md" :loading="!status || isLoading"/>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="w-full flex flex-column xl:flex-row relative xl:mb-0 mb-2">
                    <div class="w-full flex flex-column relative surface-100 gap-2
                        p-3 xl:p-4
                        border-round-xl xl:border-round-2xl">
                        <span class="flex text-sm xl:text-lg text-900">
                            Выплата: 
                        </span>
                        <span v-if="transfer.send && transfer.send.type" class="flex text-sm align-items-center">
                            <span class="text-600">Тип выплаты: </span>
                            <span class="ml-2">{{ get_payment_type_label(transfer.send.type) }}</span>
                        </span>
                        <span v-if="transfer.send.code" class="flex text-sm">
                            <span class="text-600">Платежная система: </span>
                            <span class="ml-2" v-if="transfer.send.code">{{ getPaySysTitle(transfer.send.code) }}</span>
                        </span>
                        <div v-if="transfer.send.payment_system" class="flex flex-column gap-2">
                            <span v-if="transfer.send.payment_system.comission" class="flex text-sm align-items-center">
                                <span class="text-600">Комиссия ПС выплаты: </span>
                                <span class="ml-2" v-if="transfer.send.payment_system.comission!=undefined">{{ getFormatAmount(transfer.send.payment_system.comission, 'usdt') }}</span>
                                <Tag :severity="(transfer.send.payment_system.comission_paid) ? 'success' : 'warn'" class="text-xs ml-1"
                                    :value="(transfer.send.payment_system.comission_paid) ? 'Да' : 'Нет'" />
                            </span>
                            <span v-if="transfer.send.payment_system.bank_amount" class="flex text-sm align-items-center">
                                <span class="text-600">Комиссия ПС банка выплаты: </span>
                                <span class="ml-2" v-if="transfer.send.payment_system.bank_amount!=undefined">{{ getFormatAmount(transfer.send.payment_system.bank_amount, 'usdt') }}</span>
                                <Tag :severity="(transfer.send.payment_system.bank_paid) ? 'success' : 'warn'" class="text-xs ml-1"
                                    :value="(transfer.send.payment_system.bank_paid) ? 'Да' : 'Нет'" />
                            </span>
                            <span v-if="transfer.send.payment_system.amount" class="flex text-sm">
                                <span class="text-600">Сумма: </span>
                                <span class="ml-2">{{ getFormatAmount(transfer.send.payment_system.amount, 'usdt') }}</span>
                            </span>
                        </div>
                        <div v-if="transfer?.lifecycle?.external_ops?.payout" class="flex flex-column gap-2">
                            <span v-if="transfer?.lifecycle?.external_ops?.payout?.operation_id" class="flex text-sm">
                                <span class="text-600">OP ID: </span>
                                <span class="ml-2">{{ getShortTd(transfer?.lifecycle?.external_ops?.payout?.operation_id) }}</span>
                                <span @click="copy(transfer?.lifecycle?.external_ops?.payout?.operation_id)" class="flex pi pi-copy ml-2 text-500 text-xs font-medium cursor-pointer"></span>
                                <span @click="goToOp(transfer?.lifecycle?.external_ops?.payout?.operation_id)" class="flex pi pi-external-link cursor-pointer text-xs font-medium text-primary ml-2"></span>
                            </span>
                            <span v-if="transfer?.lifecycle?.external_ops?.payout?.status" class="flex text-sm">
                                <span class="text-600">Статус: </span>
                                <span class="ml-2">{{ transfer?.lifecycle?.external_ops?.payout?.status }}</span>
                            </span>
                            <span v-if="transfer?.lifecycle?.external_ops?.payout?.idempotency_key" class="flex text-sm">
                                <span class="text-600">idempotency_key: </span>
                                <span class="ml-2">{{ getShortTd(transfer?.lifecycle?.external_ops?.payout?.idempotency_key) }}</span>
                                <span @click="copy(transfer?.lifecycle?.external_ops?.payout?.idempotency_key)" class="flex pi pi-copy ml-2 text-500 text-xs font-medium cursor-pointer"></span>
                            </span>
                            <span v-if="transfer?.lifecycle?.external_ops?.payout?.created_at" class="flex text-sm">
                                <span class="text-600">Создано: </span>
                                <span class="ml-2">{{ formatDate(transfer?.lifecycle?.external_ops?.payout?.created_at) }}</span>
                            </span>
                            <span v-if="transfer?.lifecycle?.external_ops?.payout?.completed_at" class="flex text-sm">
                                <span class="text-600">Завершено: </span>
                                <span class="ml-2">{{ formatDate(transfer?.lifecycle?.external_ops?.payout?.completed_at) }}</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="w-full flex flex-column xl:flex-row relative xl:mb-3 mb-2">
                <div class="w-full flex flex-column  relative surface-100 border-round-xl xl:border-round-2xl p-3 xl:p-4">
                    <div class="flex flex-row align-items-center justify-content-between mb-3 gap-2">
                        <span class="flex text-sm xl:text-lg text-900">
                            Файлы: 
                        </span>
                        <Button v-if="files==null && !isFilesLoading" label="Загрузить" @click="LoadFiles()"
                            size="small" outlined icon="pi pi-refresh" class="border-2 border-round-lg" severity="secondary"/>
                    </div>
                    <div v-if="files!=null" class="flex flex-row">
                        <div v-if="files.length>0" v-for="file in files"
                            class="flex flex-column gap-2 mr-2 w-full max-w-6rem surface-0 border-round-lg p-2 relative cursor-pointer">
                            <span class="flex flex-column text-xs text-600">
                                <span class="flex">{{ getShortName(file.name) }}</span><br>
                                <span class="flex">{{ formatSize(file.size) }}</span>
                            </span>
                            <Button :label="'открыть'" @click="openPopup(file.path, file.name)" class="border-round-lg border-none " icon="pi pi-eye" size="small" iconPos="right" text severity="info"/>
                            <Button :label="'скачать'" @click="downloadFile(file.path, file.name)" class="border-round-lg border-none " icon="pi pi-download" size="small" iconPos="right" text severity="info"/>
                        </div>
                        <span v-else class="flex text-sm xl:text-base text-600">
                            Файлы не загружены.
                        </span>
                    </div>
                    <span v-else-if="!isFilesLoading" class="flex text-sm xl:text-base text-600">
                        Файлы еще не загружались.
                    </span>
                </div>
            </div>
            <Skeleton v-if="isFilesLoading" height="3rem" class="border-round-xl mb-2 xl:mb-3"/>

            <div class="w-full flex flex-column xl:flex-row xl:gap-3 xl:mb-3">
                <div v-if="get_merchant" class="w-full flex flex-column relative xl:mb-0 mb-2">
                    <div v-if="transfer.get" class="w-full flex flex-column relative surface-100 border-round-xl xl:border-round-2xl p-3 xl:p-4">
                        <span class="flex text-sm xl:text-base text-600 mb-2">
                            Мерчант приема:
                        </span>
                        <div v-if="get_merchant">
                            <span v-if="get_merchant.name" class="flex text-xl xl:text-2xl font-semibold text-900 mb-3 xl:mb-4">
                                {{ get_merchant.name }}
                            </span>
                        </div>
                        <Skeleton v-else height="2rem" class="mb-2"/>

                        <div v-if="transfer.get.merchant" class="w-full flex flex-column gap-2 text-sm xl:text-base">
                            <span class="flex align-items-center">
                                <span class="text-600">Отметка мерчантом приема: </span>
                                <Tag :severity="(transfer.get.merchant.confirm) ? 'success' : 'warn'" class="text-sm ml-1"
                                    :value="(transfer.get.merchant.confirm) ? 'Да' : 'Нет'" />
                                <span v-if="transfer.get.merchant.confirm_date" class="ml-2"> 
                                    {{ formatDate(transfer.get.merchant.confirm_date) }}
                                </span>
                            </span>

                            <span class="flex" v-if="transfer.get.merchant.amount">
                                <span class="text-600">Сумма отправки мерчантом: </span>
                                <span class="ml-2">{{ getFormatAmount(transfer.get.merchant.amount, 'usdt') }}</span>
                            </span>

                            <span class="flex align-items-center" v-if="transfer.get.merchant.reward_amount">
                                <span class="text-600">Комиссия обмена: </span>
                                <span class="ml-2">{{ getFormatAmount(transfer.get.merchant.reward_amount, 'usdt') }}</span>
                                <Tag :severity="(transfer.get.merchant.reward_paid) ? 'success' : 'warn'" class="text-sm ml-1"
                                    :value="(transfer.get.merchant.reward_paid) ? 'Да' : 'Нет'" />
                                <span v-if="transfer.get.merchant.reward_paid_date" class="ml-2"> 
                                    {{ formatDate(transfer.get.merchant.reward_paid_date) }}
                                </span>
                            </span>

                            <span class="flex" v-if="transfer.get.merchant.bank_amount">
                                <span class="text-600">Комиссия банка: </span>
                                <span class="ml-2">{{ getFormatAmount(transfer.get.merchant.bank_amount, 'usdt') }}</span>
                                <span :class="(transfer.get.merchant.bank_paid) ? 'bg-green-500' : 'bg-orange-500'" class="inline ml-2 text-white border-round-md p-1 text-xs xl:px-2 xl:text-base">
                                    {{ (transfer.get.merchant.bank_paid) ? 'Да' : 'Нет' }}
                                </span>
                                <span v-if="transfer.get.merchant.bank_paid_date" class="ml-2"> 
                                    {{ formatDate(transfer.get.merchant.bank_paid_date) }}
                                </span>
                            </span>
                        </div>
                    </div>
                    <div v-if="getCard" class="w-full flex flex-column relative surface-100 border-round-xl xl:border-round-2xl overflo-hidden mt-2 xl:mt-3">
                        <div class="w-full flex flex-column relative surface-100 border-round-xl xl:border-round-2xl p-3 xl:p-4">
                            <span class="flex text-sm xl:text-base text-600 mb-3">
                                Карта мерчанта приема:
                            </span>
                            <CardWidget :card="getCard"/>
                        </div>
                    </div>  
                </div>

                <div v-if="transfer?.send?.merchant" class="w-full flex flex-column xl:flex-row relative xl:mb-0 mb-2">
                    <div v-if="transfer.send && transfer.send.merchant" 
                        class="w-full flex flex-column relative surface-100 gap-2
                        border-round-xl xl:border-round-2xl
                        p-3 xl:p-4">
                        <span class="flex text-sm xl:text-base text-600">
                            Мерчант отправки:
                        </span>
                        <div class="w-full flex flex-column gap-2">
                            <span v-if="send_merchant && send_merchant.name" 
                                class="flex text-xl xl:text-2xl font-semibold text-900">
                                {{ send_merchant.name }}
                            </span>
                            <span v-else class="flex text-xl xl:text-2xl font-semibold text-900">
                                Не указан
                            </span>
                        </div>
                        <Skeleton v-if="isLoading" height="2rem" class="mb-2"/>

                        <div v-if="transfer.send.merchant" class="w-full flex">
                            <Button v-if="transfer && !isLoading && (isUserInGroup('manager') || isUserInGroup('admin')) && (transfer.status=='process' || transfer.status=='confirmation')" 
                                @click='popupChangeSendMerchant=true;GetMerchants()' 
                                :disabled="isLoading || !transfer" 
                                :loading="!status || isLoading"
                                label="Изменить" icon="pi pi-pencil" iconPos="right" size="small" class="flex border-round-md" severity="info" />
                        </div>

                        <div v-if="transfer.send.merchant" class="w-full flex flex-column gap-2 text-sm xl:text-base">
                            <span class="flex align-items-center">
                                <span class="text-600">Отметка мерчантом отправки: </span>
                                <Tag :severity="(transfer.send.merchant.confirm) ? 'success' : 'warn'" class="text-sm ml-1"
                                    :value="(transfer.send.merchant.confirm) ? 'Да' : 'Нет'" />
                                <span v-if="transfer.send.merchant.confirm_date" class="ml-2"> 
                                    {{ formatDate(transfer.send.merchant.confirm_date) }}
                                </span>
                            </span>

                            <span class="flex" v-if="transfer.send.merchant.amount">
                                <span class="text-600">Сумма получения мерчантом: </span>
                                <span class="ml-2">{{ getFormatAmount(transfer.send.merchant.amount, 'usdt') }}</span>
                            </span>

                            <span class="flex align-items-center" v-if="transfer.send.merchant.reward_amount">
                                <span class="text-600">Комиссия обмена: </span>
                                <span class="ml-2">{{ getFormatAmount(transfer.send.merchant.reward_amount, 'usdt') }}</span>
                                <Tag :severity="(transfer.send.merchant.reward_paid) ? 'success' : 'warn'" class="text-sm ml-1"
                                    :value="(transfer.send.merchant.reward_paid) ? 'Да' : 'Нет'" />
                                <span v-if="transfer.send.merchant.reward_paid_date" class="ml-2"> 
                                    {{ formatDate(transfer.send.merchant.reward_paid_date) }}
                                </span>
                            </span>

                            <span class="flex align-items-center" v-if="transfer.send.merchant.bank_amount">
                                <span class="text-600">Комиссия банка: </span>
                                <span class="ml-2">{{ getFormatAmount(transfer.send.merchant.bank_amount, 'usdt') }}</span>
                                <Tag :severity="(transfer.send.merchant.bank_paid) ? 'success' : 'warn'" class="text-sm ml-1"
                                    :value="(transfer.send.merchant.bank_paid) ? 'Да' : 'Нет'" />
                                <span v-if="transfer.send.merchant.bank_paid_date" class="ml-2"> 
                                    {{ formatDate(transfer.send.merchant.bank_paid_date) }}
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            
            <div v-if="transfer?.status!='completed'" class="flex flex-row w-full gap-3 mt-2 pb-4
                flex-column xl:flex-row lg:flex-row md:flex-row">
                <Button @click='close()' :disabled="!canBeClosed || isLoading" severity="danger"
                    label="Закрыть" icon="pi pi-times"  iconPos="right" class="border-round-md text-xs" :loading="!status || isLoading"/>
                <Button @click='confirmForSender()' :disabled="!canConfirmBySender || isLoading"
                    label="Подтвердить за отправителя" icon="pi pi-check"  iconPos="right" class="border-round-md text-xs" :loading="!status || isLoading"/>
                <Button @click='confirmForMerchants()' :disabled="!canConfirmByMerchants || isLoading || !isUserInGroup('manager')"
                    label="Подтвердить за мерчантов" icon="pi pi-check"  iconPos="right" class="border-round-md text-xs" :loading="!status || isLoading"/>
                <Button @click='confirmForRecipient()' :disabled="!canConfirmByRecipient || isLoading"
                    label="Подтвердить за получателя" icon="pi pi-check"  iconPos="right" class="border-round-md text-xs" :loading="!status || isLoading"/>
                <Button v-if="transfer.status=='moderation'" @click='confirmModeration()' :disabled="isLoading" severity="warn"
                    label="Подтвердить модерацию" icon="pi pi-check"  iconPos="right" class="border-round-md text-xs" :loading="!status || isLoading"/>
            </div>

            <ConfirmDialog></ConfirmDialog>

            <!--popup CONFIRM for SENDER-->
            <Dialog v-if="transfer" v-model:visible="popupSender" modal header="Подтверждение за отправителя"
                class="w-full ml-4 mr-4 border-round-xl border-none" style="max-width: 560px;">
                <div class="flex w-full flex-row">
                    <div class="flex flex-1 w-full my-2 mr-2 text-sm text-500">
                        <Button label="Отменить" @click="popupSender=false" :disabled="isLoading"
                        size="large" severity="secondary"
                        class="text-sm border-round-lg xl:max-w-12rem border-none" />
                    </div>
                    <div class="flex w-full my-2">
                        <Button label="Подтвердить" @click="senderConfirm(transfer.id)"
                        :loading="isLoading" :disabled="!canConfirmBySender || isLoading || !isUserInGroup('manager')"
                        size="large" severity="primary"
                        class="flex w-full text-sm border-round-lg border-none" />
                    </div>
                </div>
            </Dialog>

            <!--popup CONFIRM for MERCHANTS-->
            <Dialog v-if="transfer" v-model:visible="popupMerchants" modal header="Подтверждение за мерчантов"
                class="w-full ml-4 mr-4 border-round-xl border-none" style="max-width: 560px;">
                <div class="flex w-full flex-column gap-3">
                    <div class="flex w-full flex-column gap-2">
                        <span class="text-sm text-600">Выберите направление подтверждения:</span>
                        <SelectButton v-model="merchantDirection" :options="getAvailableMerchantDirections()" optionLabel="name" optionValue="code"
                            placeholder="Выберите направление" class="w-full" />
                    </div>
                    <div class="flex w-full flex-row">
                        <div class="flex flex-1 w-full my-2 mr-2 text-sm text-500">
                            <Button label="Отменить" @click="popupMerchants=false" :disabled="isLoading"
                            size="large" severity="secondary"
                            class="text-sm border-round-lg xl:max-w-12rem border-none" />
                        </div>
                        <div class="flex w-full my-2">
                            <Button label="Подтвердить" @click="merchantsConfirm(transfer.id)"
                            :loading="isLoading" :disabled="!canConfirmByMerchants || !merchantDirection || isLoading || !isUserInGroup('manager')"
                            size="large" severity="primary"
                            class="flex w-full text-sm border-round-lg border-none" />
                        </div>
                    </div>
                </div>
            </Dialog>

            <!--popup CONFIRM for RECIPIENT-->
            <Dialog v-if="transfer" v-model:visible="popupRecipient" modal header="Подтверждение за получателя" 
                class="w-full ml-4 mr-4 border-round-xl border-none" style="max-width: 560px;">
                <div class="flex w-full flex-row">
                    <div class="flex flex-1 w-full my-2 mr-2 text-sm text-500">
                        <Button label="Отменить" @click="popupRecipient=false" :disabled="isLoading" 
                        size="large" severity="secondary"
                        class="text-sm border-round-lg xl:max-w-12rem border-none" />
                    </div>
                    <div class="flex w-full my-2">
                        <Button label="Подтвердить" @click="recipientConfirm(transfer.id)"
                        :loading="isLoading" :disabled="!canConfirmByRecipient || isLoading"
                        size="large" severity="primary"
                        class="flex w-full text-sm border-round-lg border-none" />
                    </div>
                </div>
            </Dialog>

            <!--popup CONFIRM MODERATION for RECIPIENT-->
            <Dialog v-if="transfer" v-model:visible="popupModeration" modal header="Подтверждение модерации" 
                class="w-full ml-4 mr-4 border-round-xl border-none" style="max-width: 560px;">
                <div class="flex w-full flex-row">
                    <div class="flex flex-1 w-full my-2 mr-2 text-sm text-500">
                        <Button label="Отменить" @click="popupModeration=false" :disabled="isLoading" 
                        size="large" severity="secondary"
                        class="text-sm border-round-lg xl:max-w-12rem border-none" />
                    </div>
                    <div class="flex w-full my-2">
                        <Button label="Подтвердить" @click="moderationConfirm(transfer.id)"
                        :loading="isLoading" :disabled="isLoading"
                        size="large" severity="warn"
                        class="flex w-full text-sm border-round-lg border-none" />
                    </div>
                </div>
            </Dialog>

            <!--popup CLOSE -->
            <Dialog v-if="transfer" v-model:visible="popupClose" modal header="Закрыть трансфер" 
                class="w-full ml-4 mr-4 border-round-xl border-none" style="max-width: 560px;">
                <div class="flex w-full flex-row">
                    <div class="flex flex-1 w-full my-2 mr-2 text-sm text-500">
                        <Button label="Отменить" @click="popupClose=false" :disabled="isLoading" 
                        size="large" severity="secondary"
                        class="text-sm border-round-lg xl:max-w-12rem surface-100 text-500 border-none" />
                    </div>
                    <div class="flex w-full my-2">
                        <Button label="Закрыть" @click="closeTransfer(transfer.id)"
                        :loading="isLoading" :disabled="!canBeClosed || isLoading"
                        size="large" severity="danger"
                        class="flex w-full text-sm border-round-lg border-none" />
                    </div>
                </div>
            </Dialog>

            <!--popup CONFIRM by MERCHANT-->
            <Dialog v-if="transfer" v-model:visible="confirm_popup" modal header="Подтверждение выплаты" 
                class="w-full ml-4 mr-4 border-round-xl" style="max-width: 560px;">
                <div class="flex w-full flex-row">
                    <div class="flex flex-1 w-full my-2 mr-2 text-sm text-500">
                        <Button v-if="isUserInGroup('manager')" label="Отменить" @click="confirm_popup=false"
                        :disabled="isLoading" 
                        class="text-sm border-round-lg xl:max-w-12rem surface-100 text-500 border-none" />
                    </div>
                    <div class="flex w-full my-2">
                        <Button v-if="isUserInGroup('manager')" label="Подтвердить" @click="merchantConfirm(transfer.id)"
                        :loading="isLoading" :disabled="!transfer.sender.confirm || isLoading" 
                        class="flex w-full p-button-lg text-sm border-round-lg font-medium text-green-600 bg-green-100 border-none" />
                    </div>
                </div>
            </Dialog>

            <!--popup CHANGE for SEND MERCHANT-->
            <Dialog v-if="transfer" v-model:visible="popupChangeSendMerchant" modal header="Подтверждение изменения мерчанта отправителя" class="w-full border-none" style="max-width: 460px;">
                <div class="flex w-full flex-column gap-3">
                    <span class="flex text-sm text-600">Выберите мерчанта отправки:</span>
                    <Select v-model="sendMerchantId" :options="merchants" optionLabel="name" optionValue="code" placeholder="Выбор мерчанта" class="w-full flex" filter/>
                </div>
                <template #footer>
                    <Button label="Отменить" @click="popupChangeSendMerchant=false" :disabled="isLoading" :loading="isLoading" class="flex" severity="secondary" />
                    <Button label="Подтвердить" @click="changeSendMerchant()"
                        :loading="isLoading" :disabled="!sendMerchantId || isLoading"
                        class="flex flex-1" severity="info" />
                </template>
            </Dialog>

            <!--ИЗМЕНЕНИЕ-->
            <Dialog header="Изменить трансфер" v-model:visible="displayDialog" modal :breakpoints="{'960px': '75vw', '640px': '90vw'}" :style="{width: '50vw'}" >
                
                <!--Статус-->
                <div class="w-full mb-3">
                    <span class="block mb-1">Статус: </span>
                    <Dropdown v-if="status" v-model="status" :options="statuses" optionLabel="name" placeholder="Статус" class="w-full md:w-14rem" />
                    <Skeleton v-else height="2rem" class="mb-1"/>
                </div>

                <!--Отметка выплаты мерчантом-->
                <!-- <div class="w-full mb-3">
                    <span class="block mb-1">Выплата мерчантом: </span>
                    <Dropdown v-model="merchant_reward_paid" :options="paid_list" optionLabel="name" placeholder="Выплата мерчантом" class="w-full md:w-14rem" />
                </div> -->

                <div class="w-full mb-3">
                    <Button label="Изменить" @click='changeTransfer()' :disabled="!status"/>
                </div>

                <template #footer>
                    <Button label="Закрыть" icon="pi pi-check" @click="closeDialog" autofocus severity="secondary"/>
                </template>
            </Dialog>

            <Dialog header="file" v-model:visible="popupFile" modal :breakpoints="{'960px': '75vw', '640px': '90vw'}" :style="{width: '50vw'}" >
                <img :src="file_url" class="w-full">
            </Dialog>

        </div>
    </template>
</Page>
</template>
<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import BigNumber from 'bignumber.js'
import { useRoute } from 'vue-router'
import Recipient from '@/components/widgets/Recipient.vue'
import RiskProfile from '@/components/widgets/transfer/RiskProfile.vue'
import CardWidget from '@/components/merchant/CardWidget.vue'
import Page from '@/components/sides/Page.vue' 
import FixedMobile from '@/components/sides/header/FixedMobile.vue'
import { BankList, PaymentSystemList } from '@/assets/js/classes/PaymentSystem.js'

export default {
    name: 'TransferCreate',
    data() {
        return {
            transfer: null,
            sender: null,
            get_merchant: null,
            send_merchant: null,
            getCard: null,
            confirm_popup: false,
            displayDialog: false,
            dialogContent: '',
            isLoading: false,
            merchant_reward_paid: {
                name: null,
                code: null
            },
            files: null,
            isFilesLoading: false,
            popupFile: false,
            file_url: null,
            type: null,
            statuses: [
                {
                    name: 'created',
                    code: 'created'
                },
            ],
            status: null,
            paid_list: [
                {
                    name: 'Оплачено',
                    code: true
                },
                {
                    name: 'Не оплачено',
                    code: false
                },
            ],
            paid: null,
            popupSender: false,
            popupMerchants: false,
            popupRecipient: false,
            popupModeration: false,
            popupClose: false,
            merchantDirectionOptions: [
                {
                    name: 'Прием',
                    code: 'get'
                },
                {
                    name: 'Выплата',
                    code: 'send'
                },
                {
                    name: 'Оба',
                    code: 'both'
                },
            ],
            merchantDirection: null,
            canConfirmByRecipient: false,
            canBeClosed: false,
            merchants: [],
            sendMerchantId: null,
            popupChangeSendMerchant: false,
            bank_list: [],
            payment_systems: [],
            currency_list: [],
        }
    },
    computed: {
        isTgApp: function () { return this.$store.getters.StateTgApp },
        isPWA: function () { return this.$store.getters.StatePWA },
        canConfirmBySender(){
            if(!this.transfer || !this.transfer.status) return false
            return this.transfer.status == 'created'
        },
        canConfirmByMerchants(){
            if(!this.transfer || !this.transfer.status || this.transfer.status!='process') return false

            const canConfirmGetMerchant = this.canConfirmMerchantDirection('get')
            const canConfirmSendMerchant = this.canConfirmMerchantDirection('send')

            return canConfirmGetMerchant || canConfirmSendMerchant
        },
        canConfirmByRecipient(){
            if(!this.transfer || !this.transfer.status) return false
            if(this.transfer.status && this.transfer.status!='confirmation') return false
            if (!this.transfer.sender) return false
            if(!this.transfer.get || !this.transfer.send) return false
            if(this.transfer.get.type) {
                if(this.transfer.get.type=='merchant' && !this.transfer.get.merchant.confirm) {
                    if(!this.transfer.sender.confirm) return false
                }
                if(this.transfer.get.type=='payment_system' && !this.transfer.get.payment_system.confirm) return false
            }
            if(this.transfer.send.type && this.transfer.send.type=='merchant') {
                if(!this.transfer.send.merchant || !this.transfer.send.merchant.confirm) return false
            }
            return true
        },
        canBeClosed(){
            if(this.transfer && this.transfer.status && 
                (this.transfer.status!='completed' && this.transfer.status!='expired' && this.transfer.status!='closed')) return true
            return false
        }
    },
    components: {
        Recipient,
        RiskProfile,
        CardWidget,
        Page,
        FixedMobile
    },
    watch: {
        
    },
    methods: {
        isUserInGroup: function (type) { 
            return this.helper.isUserInGroup(type, this.$store.getters.StateGroups)
        },
        getShortTd(value){
            return this.helper.get_short_id(value)
        },
        toTrans(id){
            if(!id) return
            window.open(`/admin/transactions/?order_id=${id}`, '_blank')
        },
        format_card(value){
            return this.helper.format_card(value)
        },
        getBankTitle(code){
            let bankObj = new BankList()
            bankObj.items = this.bank_list
            const bankCode = bankObj.GetTitle(code, 'ru')
            return (bankCode) ? bankCode : code
        },
        getBankImage(code){
            let bankObj = new BankList()
            bankObj.items = this.bank_list
            const bankCode = bankObj.GetImage(code)
            return (bankCode) ? bankCode : null
        },
        getPaySysTitle(code){
            let paySysObj = new PaymentSystemList()
            paySysObj.items = this.payment_systems
            const paySysCode = paySysObj.GetTitle(code, 'ru')
            return (paySysCode) ? paySysCode : null
        },
        getPaySysImage(code){
            let paySysObj = new PaymentSystemList()
            paySysObj.items = this.payment_systems
            const paySysCode = paySysObj.GetImage(code)
            return (paySysCode) ? paySysCode : null
        },
        confirm_show(){
            this.confirm_popup = true
        },
        getFormatAmount(value, currency, decimals = 2){
            if(!value) return '-'
            return this.helper.format_amount(value, currency, decimals)
        },
        get_short_id(value){
            return this.helper.get_short_id(value)
        },
        changeStatusPop(){
            this.displayDialog = true
        },
        confirmForSender(){
            this.popupSender = true
        },
        confirmForMerchants(){
            this.setMerchantDirectionDefault()
            this.popupMerchants = true
        },
        confirmForRecipient(){
            this.popupRecipient = true
        },  
        confirmModeration(){
            this.popupModeration = true
        },
        close(){
            this.popupClose = true
        },
        go_to_user(id){
            const go = this.$router.resolve({path: '/admin/user/' + id})
            window.open(go.href, '_blank')
        },
        go_to_sender(id) {
            if(!id) return
            window.open('/admin/senders/?id=' + id, '_blank')
        },
        get_payment_type_label(code){
            return this.helper.get_payment_type_label(code)
        },
        canConfirmMerchantDirection(direction){
            if(direction == 'get') {
                if(this.transfer && this.transfer.get && this.transfer.get.type == 'merchant' &&
                    this.transfer.get.merchant && !this.transfer.get.merchant.confirm) {
                    return true
                }
                if(this.transfer && this.transfer.get && this.transfer.get.type == 'payment_system' &&
                    this.transfer.get.payment_system && !this.transfer.get.payment_system.confirm) {
                    return true
                }
            }

            if(direction == 'send') {
                if(this.transfer && this.transfer.send && this.transfer.send.type == 'merchant' &&
                    this.transfer.send.merchant && !this.transfer.send.merchant.confirm) {
                    return true
                }
                if(this.transfer && this.transfer.send && this.transfer.send.type == 'payment_system' &&
                    this.transfer.send.payment_system && !this.transfer.send.payment_system.confirm) {
                    return true
                }
            }

            // return this.canConfirmMerchantDirection('get') && this.canConfirmMerchantDirection('send')
        },
        getAvailableMerchantDirections(){
            const options = []

            if(this.canConfirmMerchantDirection('get')) {
                options.push(this.merchantDirectionOptions.find(item => item.code == 'get'))
            }

            if(this.canConfirmMerchantDirection('send')) {
                options.push(this.merchantDirectionOptions.find(item => item.code == 'send'))
            }

            if(this.canConfirmMerchantDirection('both')) {
                options.push(this.merchantDirectionOptions.find(item => item.code == 'both'))
            }

            return options.filter(Boolean)
        },
        setMerchantDirectionDefault(){
            this.merchantDirection = null
        },
        get_payment_system_title(code){
            return this.helper.get_payment_system_title(code)
        },
        copy(text){
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: 'Скопировано', detail: text, life: 1000 })
        },
        go_chat(){
            const go = this.$router.resolve({path: '/admin/chat/' + this.transfer.sender_id})
            window.open(go.href, '_blank')
        },
        goToOp(id){
            if(!this.transfer_id) return
            window.open('/admin/operations/?transfer_id=' + this.transfer_id, '_blank')
        },
        phone_mask(phone, cur){
            return this.helper.phone_mask(phone, cur)
        },
        format_card(number){
            return this.helper.format_card(number)
        },
        getStatusLabel (status) {
            return this.helper.get_severity_status(status, 'ru')
        },
        closeDialog(){
            this.displayDialog = false
            this.dialogContent = ''
        },
        formatDate(value){
            return this.helper.format_date_short(value)
        },
        showMess(severity, summary, detail, life=3000){
            this.$toast.add({severity, summary, detail, life})
        },
        getTypeTitle(type) {
            if(!type) return '-'
            switch(type) {
                case 'transfer':
                    return 'Перевод';
                case 'bill':
                    return 'Счет';
                case 'topup':
                    return 'Пополнение';
                default:
                    return '-';
            }
        },
        calcTotalCommission(transfer){
            if(!transfer) return null
            let total = new BigNumber(0)

            // Сервис
            if(transfer.service && transfer.service.comission){
                total = total.plus(new BigNumber(transfer.service.comission || 0))
            }

            // Платежные системы: получение и отправка
            if(transfer.get && transfer.get.payment_system && transfer.get.payment_system.comission){
                total = total.plus(new BigNumber(transfer.get.payment_system.comission || 0))
            }
            if(transfer.send && transfer.send.payment_system && transfer.send.payment_system.comission){
                total = total.plus(new BigNumber(transfer.send.payment_system.comission || 0))
            }

            // Комиссии мерчантов (reward_amount) и банка (bank_amount)
            if(transfer.get && transfer.get.merchant){
                if(transfer.get.merchant.reward_amount){
                    total = total.plus(new BigNumber(transfer.get.merchant.reward_amount || 0))
                }
                if(transfer.get.merchant.bank_amount){
                    total = total.plus(new BigNumber(transfer.get.merchant.bank_amount || 0))
                }
            }
            if(transfer.send && transfer.send.merchant){
                if(transfer.send.merchant.reward_amount){
                    total = total.plus(new BigNumber(transfer.send.merchant.reward_amount || 0))
                }
                if(transfer.send.merchant.bank_amount){
                    total = total.plus(new BigNumber(transfer.send.merchant.bank_amount || 0))
                }
            }

            if(total.isGreaterThan(0)) return this.getFormatAmount(total, 'usdt')
            return null
        },
        async LoadTransfer(){
            if(!this.transfer_id) return false
            this.isLoading = true
            const transfer = await this.connect.transfer_getby_admin(this.transfer_id).then(res=>res)
            if(transfer.result) {
                this.transfer = transfer.data
                this.type = this.transfer.type

                if(this.transfer.sender && this.transfer.sender.user_id){
                    const sender_id = (this.transfer.sender.user_id) ? this.transfer.sender.user_id : null
                    const sender_fields = {
                        name: true,
                        login: true,
                        email: true,
                        phone: true,
                        prefix: true,
                        telegram: true,
                        sendpulse: true
                    }

                    const sender = await this.connect.AdminGetUserById(sender_id, sender_fields).then(res=>res)
                    if(sender.result && sender.data)this.sender = sender.data
                    else this.showMess('warn', 'Пользователь', 'не найден')
                }

                // находим мерчанта получения
                if(this.transfer.get && this.transfer.get.type && this.transfer.get.type=='merchant' && this.transfer.get.merchant){
                    if(this.transfer.get.merchant.merchant_id){
                        const resGetMerchant = await this.connect.get_merchant_by_id(this.transfer.get.merchant.merchant_id, 30).then(res=>res)
                        if(resGetMerchant.result){
                            this.get_merchant = resGetMerchant.data
                        }
                    }

                    // находим карту
                    if(this.transfer.get.merchant.card_id){
                        const getCard = await this.connect.get_card_by_id(this.transfer.get.merchant.card_id).then(res=>res)
                        if(getCard.result && getCard.data) this.getCard = getCard.data
                        else this.showMess('warn', 'Карта мерчанта', 'не найдена')
                    }
                }

                // находим мерчанта отправки
                if(this.transfer.send && this.transfer.send.type && this.transfer.send.type=='merchant' && this.transfer.send.merchant && this.transfer.send.merchant.merchant_id){
                    const resSendMerchant = await this.connect.get_merchant_by_id(this.transfer.send.merchant.merchant_id, 30).then(res=>res)
                    if(resSendMerchant.result){
                        this.send_merchant = resSendMerchant.data
                        this.sendMerchantId = this.transfer.send.merchant.merchant_id
                    }
                }

                // указываем статус
                this.status = {
                    name: this.transfer.status,
                    code: this.transfer.status
                }

                // отметка платежной системы (устарело)
                this.paid = {
                    name: (this.transfer.paid) ? 'Оплачено' : 'Не оплачено',
                    code: this.transfer.paid
                }
                
                // отметка выплаты мерчантом
                this.merchant_reward_paid = {
                    name: (this.transfer.merchant_reward_paid) ? 'Оплачено' : 'Не оплачено',
                    code: this.transfer.merchant_reward_paid
                }
            }
            this.isLoading = false
        },
        async LoadFiles(){
            if(!this.transfer_id) return false
            this.isFilesLoading = true
            const files = await this.connect.files_list(10, 0, {transfer_id: {value: this.transfer_id}}, {}).then(res => res)
            if (files.result && files.data.length > 0) this.files = files.data
            else {
                this.files = []
                this.showMess('warn', 'Внимание', 'Файлы не найдены')
            }
            this.isFilesLoading = false
        },
        async changeSendMerchant(){
            this.isLoading = true
            const data = {
                id: this.transfer_id,
                send_merchant_id: this.sendMerchantId
            }
            await this.changeTransfer(data).then(res => res)
            await this.LoadTransfer().then(res => res)
            this.isLoading = false
        },
        async changeTransfer(data){
            if(!data){
                this.showMess('warn', 'Внимание', 'Не указаны данные для изменения')
                return false
            }
            const upd = await this.connect.transfer_upd_by_admin(data).then(res=>res)
            if(upd.result && upd.data){
                this.showMess('success', 'Успех', 'Трансфер изменен')
                this.displayDialog = false
            }else{
                if(upd.errors) {
                    for (let i = 0; i < upd.errors.length; i++) {
                        this.showMess('error', 'Ошибка', upd.errors[i])
                    }
                } else {
                    this.showMess('error', 'Ошибка', 'Ошибка при изменении транфсера')
                }
            }
        },
        async merchantConfirm(){
            this.isLoading = true
            const confirm = await this.connect.transfer_confirm_by_merchant(this.transfer.id).then(res=>res)
            if(confirm.result){
                this.isLoading = false
                this.confirm_popup = false
                this.transfer.merchant_confirm = true
                this.transfer.merchant_confirm_date = new Date()
                this.transfer.status = 'completed'
                this.showMess('success', 'Успех', 'Выплата подтверждена')
            }else{
                if(confirm.message) this.showMess('warn', 'Ответ', confirm.message)
                else if(confirm.errors) {
                    for (let i = 0; i < confirm.errors.length; i++) {
                        this.showMess('error', 'Ошибка', confirm.errors[i])
                    }
                }else{
                    this.showMess('error', 'Ошибка', 'Ошибка при изменении статуса')
                }
                this.isLoading = false
            }
        },
        async recipientConfirm(){
            this.isLoading = true
            const confirm = await this.connect.ConfirmTransferForRecipientByAdmin(this.transfer.id).then(res=>res)
            if(confirm.result && confirm.data){
                this.transfer.merchant_confirm = true
                this.transfer.merchant_confirm_date = new Date()
                this.transfer.status = 'completed'
                this.showMess('success', 'Успех', 'Вы подтвердили получение клиентом')
            }else{
                if(confirm.message) this.showMess('warn', 'Ответ', confirm.message)
                else if(confirm.errors) {
                    for (let i = 0; i < confirm.errors.length; i++) {
                        this.showMess('error', 'Ошибка', confirm.errors[i])
                    }
                } else {
                    this.showMess('error', 'Ошибка', 'Ошибка при подтверждении получения')
                }
            }
            this.isLoading = false
            this.popupRecipient = false
        },
        async senderConfirm(){
            this.isLoading = true
            const confirm = await this.connect.ConfirmTransferForSenderByAdmin(this.transfer.id).then(res=>res)
            if(confirm.result && confirm.data){
                await this.LoadTransfer().then(res => res)
                this.showMess('success', 'Успех', 'Вы подтвердили перевод за отправителя')
            }else{
                if(confirm.message) this.showMess('warn', 'Ответ', confirm.message)
                else if(confirm.errors) {
                    for (let i = 0; i < confirm.errors.length; i++) {
                        this.showMess('error', 'Ошибка', confirm.errors[i])
                    }
                } else {
                    this.showMess('error', 'Ошибка', 'Ошибка при подтверждении за отправителя')
                }
            }
            this.isLoading = false
            this.popupSender = false
        },
        async merchantsConfirm(){
            this.isLoading = true
            const confirm = await this.connect.ConfirmTransferForMerchantsByAdmin(this.transfer.id, this.merchantDirection).then(res=>res)
            if(confirm.result && confirm.data){
                await this.LoadTransfer().then(res => res)
                this.showMess('success', 'Успех', 'Вы подтвердили перевод за мерчантов')
            }else{
                if(confirm.message) this.showMess('warn', 'Ответ', confirm.message)
                else if(confirm.errors) {
                    for (let i = 0; i < confirm.errors.length; i++) {
                        this.showMess('error', 'Ошибка', confirm.errors[i])
                    }
                } else {
                    this.showMess('error', 'Ошибка', 'Ошибка при подтверждении за мерчантов')
                }
            }
            this.isLoading = false
            this.popupMerchants = false
            this.merchantDirection = null
        },
        async moderationConfirm(){
            this.isLoading = true
            const confirm = await this.connect.ConfirmTransferFromModerationByAdmin(this.transfer.id).then(res=>res)
            if(confirm.result && confirm.data){
                this.transfer.merchant_confirm = true
                this.transfer.merchant_confirm_date = new Date()
                this.transfer.status = 'process'
                this.showMess('success', 'Успех', 'Вы подтвердили получение клиентом')
            }else{
                if(confirm.message) this.showMess('warn', 'Ответ', confirm.message)
                else if(confirm.errors) {
                    for (let i = 0; i < confirm.errors.length; i++) {
                        this.showMess('error', 'Ошибка', confirm.errors[i])
                    }
                } else {
                    this.showMess('error', 'Ошибка', 'Ошибка при подтверждении получения')
                }
            }
            this.isLoading = false
            this.popupModeration = false
        },
        async closeTransfer(){
            this.isLoading = true
            const close = await this.connect.CloseTransferByAdmin(this.transfer.id).then(res=>res)
            if(close.result && close.data){
                this.transfer.status = 'closed'
                this.showMess('success', 'Успех', 'Трансфер закрыт')
            }else{
                if(close.message) this.showMess('warn', 'Ответ', close.message)
                else if(close.errors) {
                    for (let i = 0; i < close.errors.length; i++) {
                        this.showMess('error', 'Ошибка', close.errors[i])
                    }
                } else {
                    this.showMess('error', 'Ошибка', 'Ошибка при закрытии транфсера')
                }
            }
            this.isLoading = false
            this.popupClose = false
        },
        async checkPayment(){
            this.isLoading = true 
            try{
                let payment = await this.connect.CheckPaymentStatusByAdmin(this.transfer.id).then(res=>res)
                if(payment.result && payment.data) {
                    this.isLoading = false
                    this.transfer.payment_system_confirm = true
                    this.showMess(
                        'success', 
                        payment.data.message || 'Успех', 
                        payment.data.text || 'Статус оплаты обновлен',
                        5000
                    )
                }else{
                    if(payment.message) this.showMess('warn', 'Ответ', payment.message)
                    else this.showMess('warn', 'Ответ', 'Неизвестный ответ от платежной системы')
                }
            }   catch (e) {
                this.isLoading = false
                this.showMess('error', 'Ошибка', e)
            }
            this.isLoading = false
        },
        formatSize(bytes) {
            const k = 1024;
            const dm = 3;
            const sizes = this.$primevue.config.locale.fileSizeTypes;

            if (bytes === 0) {
                return `0 ${sizes[0]}`;
            }

            const i = Math.floor(Math.log(bytes) / Math.log(k));
            const formattedSize = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));

            return `${formattedSize} ${sizes[i]}`;
        },
        getShortName(name){
            if(name.length > 20){
                return '...' + name.slice(-8)
            } else {
                return name
            }
        },
        downloadFile(path, name){
            if(!path || !name) return
            this.saveFile(path, name)
        },
        async saveFile(path, name) {
            if(!path) return
            if(!name) return
            const file = await this.connect.get_file(path).then(res => res)
            if (file) {
                const url = window.URL.createObjectURL(file)
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', name)
                document.body.appendChild(link)
                link.click()
            } else {
                this.file_url = null
                this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'Файл не найден', life: 3000 })
            }
        },
        async getFile(path) {
            if(!path) return
            const file = await this.connect.get_file(path).then(res => res)
            if (file) {
                const url = window.URL.createObjectURL(new Blob([file]))
                this.file_url = url
            } else {
                this.file_url = null
                this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'Файл не найден', life: 3000 })
            }
        },
        async GetMerchants(){
            const merchants = await this.connect.merchant_list(100, 0, {}, {}).then(res => res)
            if (merchants.result && merchants.data.length > 0) {
                for(let i = 0; i < merchants.data.length; i++){
                    this.merchants.push({
                        name: merchants.data[i].name,
                        code: merchants.data[i].id
                    })
                }
            } else {
                this.merchants = []
                this.showMess('warn', 'Внимание', 'Мерчанты не найдены')
            }
        },
        openPopup(path) {
            if(!path) return
            this.popupFile = true
            this.getFile(path)
        },
        async LoadBankList(){
            this.bank_list = await BankList.GetList(this.$store).then(r=>r)
            if(!this.bank_list || !this.bank_list.length) this.bank_list = []
        },
        async LoadPaymentSystems(){
            this.payment_systems = await PaymentSystemList.GetList(this.$store).then(r=>r)
            if(!this.payment_systems || !this.payment_systems.length) this.payment_systems = []
        },
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
        const route = useRoute()
        if(route.params.id!='' && this.helper.is_id(route.params.id)) this.transfer_id = route.params.id
    },
    async mounted() {
        await this.LoadTransfer().then(res => res)
        // await this.LoadFiles().then(res => res)
        // await this.GetMerchants().then(res => res)
        this.LoadBankList()
        this.LoadPaymentSystems()
    },
}
</script>

 

